import { api } from './client.js';

/** card_list 의 컬럼 그대로. 입금건(BankEditBody)과 같은 자리의 값만 이름이 다르다. */
export interface CardEditBody {
  card_type: string;
  use_area?: number;
  se_name?: string;
  up_name: string;
  amount: string | number;
  amount_us?: string | number;
  us_rate?: string | number;
  cardmemo?: string;
  memo?: string;
  /** 처리 이력 - 수정에서만 보낸다(등록 폼에는 없다). */
  re_name?: string;
  report_date?: string;
  succ_date?: string;
}

/** corp(법인)는 등록할 때만 정해진다 - 입금건의 BankCreateBody 와 같다. */
export interface CardCreateBody extends CardEditBody {
  corp: string;
}

/**
 * 목록 조회는 그대로 정의 기반 화면(report.registry.ts 의 payment-card)을 쓴다.
 * 여기서는 카드건 직접 등록·수정(입금건의 paymentBankApi.create/update 와 같은
 * 자리)만 감싼다.
 */
export const paymentCardApi = {
  create: (body: CardCreateBody) => api.post<{ seq: string }>('/payment/card', body),

  update: (seq: number, body: CardEditBody) => api.patch(`/payment/card/${seq}`, body),

  /** 소프트 삭제 - 입금건(paymentBankApi.remove)과 같다. */
  remove: (seq: number) => api.del(`/payment/card/${seq}`),
};
